import ArtVsArtist from '../components/gallery/ArtVsArtist'
import Home from '../components/Home'
import ClusterA from '../components/ClusterA'

export default [
  {
    id: 1,
    name: 'T',
    path: '',
    component: <Home />,
  },
  {
    id: 2,
    name: 'H',
    path: 'art-vs-artist',
    component: <ArtVsArtist />,
  },
  {
    id: 3,
    name: 'E',
    path: 'art-vs-artist',
    component: <ArtVsArtist />,
  },
  {
    id: 4,
    name: ' ',
    path: 'art-vs-artist',
    component: <ArtVsArtist />,
  },
  {
    id: 5,
    name: '1',
    path: 'art-vs-artist',
    component: <ArtVsArtist />,
  },
  {
    id: 6,
    name: '9',
    path: 'art-vs-artist',
    component: <ArtVsArtist />,
  },
  {
    id: 7,
    name: '7',
    path: 'art-vs-artist',
    component: <ArtVsArtist />,
  },
  {
    id: 8,
    name: '9',
    path: 'art-vs-artist',
    component: <ArtVsArtist />,
  },
  {
    id: 9,
    name: ' ',
    path: 'art-vs-artist',
    component: <ArtVsArtist />,
  },
  {
    id: 10,
    name: 'B',
    path: 'cluster-b',
    component: <ArtVsArtist />,
  },
  {
    id: 11,
    name: 'I',
    path: 'art-vs-artist',
    component: <ArtVsArtist />,
  },
  {
    id: 12,
    name: 'Z',
    path: 'art-vs-artist',
    component: <ArtVsArtist />,
  },
  {
    id: 13,
    name: 'A',
    path: 'cluster-a',
    component: <ClusterA />,
  },
  {
    id: 14,
    name: 'R',
    path: 'reset',
    component: <ArtVsArtist />,
  },
  {
    id: 15,
    name: 'R',
    path: 'reset',
    component: <ArtVsArtist />,
  },
  {
    id: 16,
    name: 'E',
    path: 'art-vs-artist',
    component: <ArtVsArtist />,
  },
]
